// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/loader-wrapper/loader-wrapper/loader-wrapper.component.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;;AAGC;EACG,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ","sourcesContent":["\n\n.spinner-container{\n    position: fixed;\n    top:0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    background:rgb(0 0 0 / 50%);\n    z-index: 99;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n .card {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
